import { render, staticRenderFns } from "./CampaignRegister.vue?vue&type=template&id=78ad1620&scoped=true"
import script from "./CampaignRegister.vue?vue&type=script&lang=js"
export * from "./CampaignRegister.vue?vue&type=script&lang=js"
import style0 from "./CampaignRegister.vue?vue&type=style&index=0&id=78ad1620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad1620",
  null
  
)

export default component.exports